
export const byCreated = (current, next) => {
  return current.created < next.created ? 1 : current.created > next.created ? -1 : 0;
};
